import React from 'react';
import { motion } from 'framer-motion';
import { appLanguages } from '../data/translations';

const LanguageSelector = ({ currentLanguage, onLanguageChange, onClose }) => {
  const handleLanguageSelect = (langCode) => {
    onLanguageChange(langCode);
    onClose();
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -10, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -10, scale: 0.95 }}
      transition={{ duration: 0.2 }}
      className="absolute top-full right-0 mt-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-xl z-50 min-w-[180px] max-h-80 overflow-y-auto"
    >
      {appLanguages.map((language) => (
        <motion.button
          key={language.code}
          whileHover={{ backgroundColor: 'rgba(147, 51, 234, 0.1)' }}
          onClick={() => handleLanguageSelect(language.code)}
          className={`w-full flex items-center space-x-3 px-4 py-3 text-left hover:bg-purple-50 dark:hover:bg-purple-900/20 transition-colors ${
            currentLanguage === language.code 
              ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300' 
              : 'text-gray-900 dark:text-white'
          }`}
        >
          <span className="text-xl">{language.flag}</span>
          <span className="font-medium">{language.name}</span>
        </motion.button>
      ))}
    </motion.div>
  );
};

export default LanguageSelector;